import { Roles } from "../../../constants/roles";
import { NavbarHamburgerForm } from "./navbar-hamburger-form";
import { NavbarHamburgerHandler } from "./navbar-hamburger-handler";
import { NavbarHamburgerListener } from "./navbar-hamburger-listener";

export class NavbarHamburgerSetup {
    public form: NavbarHamburgerForm;

    public handler: NavbarHamburgerHandler;

    public listener: NavbarHamburgerListener;

    public constructor(root: HTMLElement) {
        this.form = new NavbarHamburgerForm(root);
        this.handler = new NavbarHamburgerHandler(this.form);
        this.listener = new NavbarHamburgerListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) return;

        this.handler.bootstrap();
        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: Document | HTMLElement | ParentNode = document): void {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;

        const targets: HTMLElement[] = [];
        if (root instanceof HTMLElement && root.matches(`[data-role="${Roles.NAVBAR_CONTENT}"]`)) {
            targets.push(root);
        }

        NavbarHamburgerForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        targets.forEach((target) => {
            const setup = new NavbarHamburgerSetup(target);
            setup.init();
        });
    }
}
